<template>
  <Modal
    class="modal-reward"
    :name="modalName"
    :show-close="false"
    :cover-closeable="false"
    :close-btn-handler="handleClose"
    @modalClose="handleClose"
  >
    <div class="content" slot="modal-content">
      <div class="reward-box auto_scale">
        <div class="reward-title" v-html="dataAward.award_abstract || '恭喜你获得'"></div>
        <div class="reward-wrap" ref="reward-wrap">
          <!-- 这里为了去除滚动条，套了2层div元素 -->
          <div class="reward-scroll">
            <div class="item" v-for="(item, i) in dataAward.award_list" :key="i">
              <p class="title">{{item.name}}</p>
              <p class="des">{{item.synopsis}}</p>
              <p class="money"><span>¥</span>{{item.max_amount}}</p>
            </div>
          </div>
        </div>
        <!-- 非微信端 & 微信小程序 & 微信端 按钮展示 -->
        <div
          :class="{'reward-btn': true,'gray': isGray}"
          v-html="mainData.award_result_button_desc || '获取更多优惠'"
          v-if="!isWeixin"
          @click="btnClickHandle(true)"
        ></div>
        <!-- 微信小程序什么都不展示 -->
        <div v-else-if="isWeixinMini === 'weixinmini'"></div> 
        <div
          class="btn-in-weixin"
          v-else
        ></div>
        <!-- 倒计时文案 -->
        <div class="tips" v-if="isShowTips">领取成功，正在为你跳转高德打车（{{dateCount}}）</div>
      </div>
      <!-- 引导呼气逻辑蒙层 -->
      <div class="reward-mask" v-if="isShowGuide">
        <div class="arrow"></div>
        <div v-if="!isIos" class="guard android"></div>
        <div v-if="isIos" class="guard ios"></div>
      </div>
    </div>
  </Modal>
</template>
<script>
import {
  log, webviewInfo, util, os
} from '@ali/amap-lib';
import genOpenAmapMixin from '../../js/gen-openamap-mixin';
import browserApi from '../../js/amap-browser';
import service from '../../js/service';
import jump from '../../js/jumpHandler'
import BScroll from '@better-scroll/core'

import Modal from '../Modal.vue';

const openAmapMixin = genOpenAmapMixin();

const alipayTaxiSchema = 'alipays://platformapi/startapp?appId=20002047&scene=amapOnlineRide'


export default {
  mixins: [openAmapMixin],
  data() {
    return {
      modalName: 'modalRewardShow',
      isGray: false, // 按钮置灰
      isSafari: false, // 是否浏览器环境
      isWeixin: false, // 是否微信环境
      isWeixinMini: service.browserEnvironment(), //是否微信小程序
      isInAmap: false, // 是否端内环境
      isIos: false, // 是否ios
      isShowTips: false, // 是否显示3s倒计时跳转
      isShowGuide: false, // 是否显示引导
      dateCount: 2,
      gdFrom: '',
      scroller: null,
    };
  },
  props: {
    mainData: {
      required: true,
      type: Object,
      default() {
        return {};
      },
    },
    dataAward: {
      type: Object,
      default() {
        return {};
      },
    },
    mini_app: {
      type: Number,
    },
    isAliPayMainEntry: {
      // 是否为支付宝金刚位
      type: Boolean,
      default: false,
    }
  },
  components: {
    Modal,
  },
  created() {
    const UA = window.navigator.userAgent.toLowerCase();
    this.isSafari = (/safari/.test(UA));
    this.isWeixin = webviewInfo.isInWeixin();
    this.isInAmap = this.$root.isInAmap;
    this.gdFrom = util.getUrlParam('gd_from');
    this.isIos = os.ios;
    console.log('是否是微信小程序呀：', this.isWeixinMini);
  },
  mounted() {
    // 端外3s倒计时呼起
    if (!this.isInAmap) {
      this.outsideHandle();
    } else {
      this.insideHandle();
    }
    this.createScroll();
  },
  methods: {
    // 是否显示右上角箭头引导蒙层
    showGuideHandle(flag) {
      if (this.isWeixin && this.isWeixinMini !== 'weixinmini') { // 是微信 但是不是微信小程序
        this.isShowGuide = flag;
      } else {
        this.isShowGuide = false;
      }
    },
    // 端外呼起端内处理函数，3s倒计时
    outsideHandle() {
      log.log('result_jump', {
        source: this.gdFrom,
        type: service.browserEnvironment(),
        url: window.location.href,
        text: navigator.userAgent
      });
      if(this.isWeixinMini === 'weixinmini') return;
      this.isShowTips = true;
      let timer = setInterval(() => {
        this.dateCount--;
        if (this.dateCount === 0) {
          clearInterval(timer);
          timer = null;
          this.dateCount = 2;
          this.isShowTips = false;
          this.btnClickHandle();
        }
      }, 1000);
    },
    // 端内呼起逻辑处理，3s延时
    insideHandle() {
      // 这里把弹窗动画时间也算进去，加 1s，共4s
      setTimeout(() => {
        this.btnClickHandle();
      }, 4000);
    },
    // 跳转小程序
    goAlipay() {
      log.logJump(() => {
        browserApi.openAmap('alipays://platformapi/startapp?appId=2018070960585195&page=page/map-index/map-index&query=channel%3Ddwfq');
      }, 'gocar', {
        url: window.location.href
      });
    },
    // 按钮点击处理
    btnClickHandle(autoopen = false) {
      console.log('reward-modal, btn-ClickHandle');
      console.log('isAliPayMainEntry', this.isAliPayMainEntry)
      const self = this;
      if(this.isAliPayMainEntry) {
        // 跳转支付宝打车
        console.log('跳转支付宝打车')
        window.location.href = alipayTaxiSchema
      }else if (+this.mini_app === 1) { // 跳转小程序
        if (this.isWeixin) {
          this.isShowGuide = true;
          this.openAmapClickHandle('taxi', autoopen, this.dataAward.token || ''); // 端外，呼起到端内打车 拼接微信token
        } else if (service.browserEnvironment() === 'Alipay') { // 本身就在小程序里 不跳转修改
          /* eslint-disable */
            my.getEnv((res) => {
              if (res.miniprogram) {
                /* eslint-disable */
                my.postMessage({ eventType: 'JUMP_INDEX_PAGE' });
              } else {
                self.goAlipay()
              }
            });
        } else {
          self.goAlipay();
        }
      } else if (!this.isInAmap) {
        if (service.browserEnvironment() === 'Alipay') {
          /* eslint-disable */
          my.getEnv((res) => {
            console.log(res, '小程序环境变量');
            if (res.miniprogram) {
              /* eslint-disable */
              my.postMessage({ eventType: 'JUMP_INDEX_PAGE' });
            } else {
              this.showGuideHandle(true);
              this.openAmapClickHandle('taxi', autoopen, this.dataAward.token || ''); // 端外，呼起到端内打车
            }
          });
        } else {
          this.showGuideHandle(true);
          this.openAmapClickHandle('taxi', autoopen, this.dataAward.token || ''); // 端外，呼起到端内打车
        }
      } else {
        this.amapJumpTaxiPage(); // 端内，直接跳转打车
      }
    },
    // 关闭弹窗
    handleClose() {
      this.isShowGuide = false;
      this.$emit('modalHandler', 'modalClose', this.modalName);
    },
    createScroll(){
      if(!this.scroller) {
        this.scroller = new BScroll(this.$refs['reward-wrap'])
      }else {
        this.scroller.refresh();
      }
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../css/common-mixin";
.modal-reward {
  .content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .reward-box {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: rpx(642);
    height: rpx(816);
    border-radius: rpx(16);
    background-image: url('../../../assets/modal/reward/reward-bg.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: rpx(624) rpx(816);
    padding-top: rpx(190);
    .reward-title {
      font-size: rpx(39);
      color: #fff;
      text-align: center;
      margin-bottom: rpx(28);
    }
    .reward-wrap {
      margin: auto;
      width: rpx(512);
      height: rpx(380);
      margin-bottom: rpx(37);
      overflow-x: hidden;
      overflow-y: auto;
      .reward-scroll {
        width: 100%;
        // height: 100%;
        padding-right: rpx(50);
        // box-sizing: content-box;
        overflow-x: hidden;
        overflow-y: auto;
        // -webkit-overflow-scrolling: touch;
        .item {
          width: rpx(512);
          height: rpx(142);
          margin-bottom: rpx(20);
          background: url('../../../assets/modal/reward/reward-box.png') no-repeat center center;
          background-size: 100% 100%;
          padding-left: rpx(33);
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .title {
            font-size: rpx(29);
            color: #323232;
          }
          .des {
            font-size: rpx(24);
            color: #999999;
          }
          .money {
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
            width: rpx(155);
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: rpx(49);
            color: #F2493D;
            span {
              display: inline-block;
              font-size: rpx(33);
              height: rpx(49);
              line-height: rpx(55);
              margin-right: 2px;
            }
          }
        }
      }
    }
    .reward-btn {
      margin: auto;
      width: rpx(482);
      height: rpx(77);
      color: #4C3300;
      font-size: rpx(32);
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: url('../../../assets/modal/reward/reward-btn.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
      &.gray {
        background-image: url('../../../assets/modal/reward/reward-btn-gray.png');
        background-size: 100% 100%;
      }
    }
    .btn-in-weixin {
      margin: auto;
      width: rpx(482);
      height: rpx(77);
      background: url('../../../assets/modal/reward/reward-btn-text.png') no-repeat center center;
      background-size: rpx(446) rpx(42);
      text-align: center;
    }
    .tips {
      margin-top: rpx(55);
      text-align: center;
    }
  }
}
.openamap-guide {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  width: rpx(348);
  height: rpx(218);
  background-image: url('../../../assets/modal/reward/open-browser.png');
  background-size: rpx(348) rpx(218);
  background-repeat: no-repeat;
  background-position: center center;
  &.openamap-safari {
    background-image: url('../../../assets/modal/reward/open-safari.png');
    background-size: rpx(348) rpx(218);
  }
}


.reward-mask {
  position: fixed;
  width: 100%;
  // height: 100%;
  height: rpx(300);
  top: 0;
  left: 0;
  z-index: 10;
  // background: rgba(0, 0, 0, 0.6);
  .arrow {
    position: absolute;
    right: rpx(40);
    top: rpx(30);
    width: rpx(115);
    height: rpx(79);
    background: url("~assets/index/mask/arrow.png") no-repeat;
    background-size: contain;
    animation: shake 1s ease-in-out infinite normal;
    @keyframes shake {
      0% {
        transform: translate(0, 0);
      }
      25% {
        transform: translate(0, -0.1rem);
      }
      50% {
        transform: translate(0, 0);
      }
      70% {
        transform: translate(0px, -0.05rem);
      }
      100% {
        transform: translate(0, 0);
      }
    }
  }
  .guard {
    position: absolute;
    right: rpx(140);
    top: rpx(20);
    &.android {
      width: rpx(317);
      height: rpx(149);
      background: url("~assets/index/mask/more-and.png") no-repeat left center;
      background-size: rpx(317) rpx(149);
    }
    &.ios {
      width: rpx(317);
      height: rpx(149);
      background: url("~assets/index/mask/more-ios.png") no-repeat left center;
      background-size: rpx(317) rpx(149);
    }
  }
}
</style>
